import BuildIcon from '@mui/icons-material/Build';
import HistoryIcon from '@mui/icons-material/History';
import {Button, Grid, Paper, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {LoadingIndicator} from "../../components/LoadingIndicator";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

export class FixMira extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            pedestal: {
                user: [],
                total: 0,
                amount: 100,
                offset: 0,
                userPedestal: "",
                progress: {
                    amount: 0,
                    totalUser: 0,
                    action: "Fix Pedestal"
                },
                progressInterval: null,
                fixNewPedestal: false,
            },
            mira: {
                user: [],
                total: 0,
                amount: 100,
                offset: 0,
                userPedestal: "",
                progress: {
                    amount: 0,
                    refundAmount: 0,
                    totalUser: 0,
                    action: "Refund Mira"
                },
                progressInterval: null,
            },

            building: {
                user: [],
                total: 0,
                amount: 100,
                offset: 0,
                userPedestal: "",
                progress: {
                    amount: 0,
                    totalUser: 0,
                    action: "Fix Building"
                },
            },
            loading: false,

        }
    }

    componentDidMount() {
        this.getPedestalAmount();
        this.getRefundMiraAmount();
        this.getBuildingAmount();
    }

    getPedestalAmount = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/fix_pedestal_amount`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const total = data.amount;
            const {pedestal} = this.state;

            pedestal.total = total;
            this.setState({pedestal});
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    getRefundMiraAmount = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/refund_mira_amount`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const total = data.amount;
            const {mira} = this.state;

            mira.total = total;
            this.setState({mira});
        } else {
            PopupMessage.error("getRefundMiraAmount Failed");
        }
    }

    getBuildingAmount = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/fix_mira_building_amount`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const total = data.amount;
            const {building} = this.state;

            building.total = total;
            this.setState({building});
        } else {
            PopupMessage.error("getBuildingAmount Failed");
        }
    }

    getListUser = async () => {
        const {pedestal} = this.state;
        const {offset, amount} = pedestal;
        const url = `${Config.getInstance.apiUrl}/api/users/fix_pedestal_id`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            offset,
            amount,
        }

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const users = data.users;
            pedestal.user = users;

            this.setState({pedestal});

            const userList = users.map((user) => user.user_id).join(",");

            this.copyToClipboard(userList);
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    getListRefundMira = async () => {

        const {mira} = this.state;
        const {offset, amount} = mira;
        const url = `${Config.getInstance.apiUrl}/api/users/refund_mira_id`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            offset,
            amount,
        }

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const users = data.users;
            mira.user = users;

            this.setState({mira});

            const userList = users.map((user) => user.user_id).join(",");

            this.copyToClipboard(userList);
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    getListBuilding = async () => {

        const {building} = this.state;
        const {offset, amount} = building;
        const url = `${Config.getInstance.apiUrl}/api/users/fix_mira_building_id`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            offset,
            amount,
        }

        console.log("url", url)
        console.log("headers", headers)
        console.log("body", body)

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const users = data.users;
            building.user = users;

            this.setState({building});

            const userList = users.map((user) => user.user_id).join(",");

            this.copyToClipboard(userList);
        } else {
            PopupMessage.error("getListBuilding Failed");
        }
    }

    copyToClipboard = async (text) => {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onChangePedestalData = (e, key) => {
        const {pedestal} = this.state;
        pedestal[key] = e.target.value;
        this.setState({pedestal});
    }

    onChangeMiraData = (e, key) => {
        const {mira} = this.state;
        mira[key] = e.target.value;
        this.setState({mira});
    }

    onChangeBuildingData = (e, key) => {
        const {building} = this.state;
        building[key] = e.target.value;
        this.setState({building});
    }


    onFixPedestal = async () => {
        const {pedestal} = this.state;
        const {userPedestal} = pedestal;
        const url = `${Config.getInstance.apiUrl}/api/users/fix_pedestal`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            userIds: userPedestal,
        }

        const {progress} = pedestal;
        const totalUser = userPedestal.split(",").length;

        progress.totalUser = totalUser;

        this.setState({loading: true, pedestal});

        const response = await axios.post(url, body, {headers});

        this.setState({loading: false});

        const data = response.data;

        const success = data.success;

        this.getPedestalAmount();

        if (success) {
            const pedestalAmount = data.pedestalAmount;
            const miraAmount = data.miraAmount;
            progress.amount = pedestalAmount;
            progress.action = "Fix Pedestal";
            pedestal.progress = progress;

            const {mira} = this.state;
            const miraProgress = mira.progress;
            miraProgress.amount = miraAmount;

            this.setState({pedestal, mira});
            PopupMessage.success("Fix Pedestal Success");
        } else {
            PopupMessage.error("Fix Pedestal Failed");
        }
    }

    onRefundMira = async () => {
        const {mira} = this.state;
        const {userPedestal} = mira;
        const url = `${Config.getInstance.apiUrl}/api/users/refund_mira`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            userIds: userPedestal,
        }

        const {progress} = mira;
        const totalUser = userPedestal.split(",").length;

        progress.totalUser = totalUser;

        this.setState({loading: true, mira});

        const response = await axios.post(url, body, {headers});

        this.setState({loading: false});

        const data = response.data;

        const success = data.success;

        this.getPedestalAmount();

        if (success) {
            const userAmount = data.userAmount;
            const totalAmount = data.totalAmount;
            progress.amount = userAmount;
            progress.refundAmount = totalAmount;
            progress.action = "Refund Mira";
            mira.progress = progress;

            this.setState({mira});
            PopupMessage.success("Refund Success");
        } else {
            PopupMessage.error("Refund Failed");
        }
    }

    onFixBuilding = async () => {
        const {building} = this.state;
        const {userPedestal} = building;
        const url = `${Config.getInstance.apiUrl}/api/users/fix_mira_building`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            userIds: userPedestal,
        }

        const {progress} = building;
        const totalUser = userPedestal.split(",").length;

        progress.totalUser = totalUser;

        this.setState({loading: true, building});

        const response = await axios.post(url, body, {headers});

        this.setState({loading: false});

        const data = response.data;

        const success = data.success;

        this.getPedestalAmount();

        if (success) {
            const userAmount = data.userAmount;
            progress.amount = userAmount;
            progress.action = "Fix Building";
            building.progress = progress;

            this.setState({building});
            PopupMessage.success("Refund Success");
        } else {
            PopupMessage.error("Refund Failed");
        }
    }

    onRevertFixPedestal = async () => {
        const {pedestal} = this.state;
        const {userPedestal} = pedestal;
        const url = `${Config.getInstance.apiUrl}/api/users/revert_pedestal`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            userIds: userPedestal,
        }

        const {progress} = pedestal;
        const totalUser = userPedestal.split(",").length;

        progress.totalUser = totalUser;

        this.setState({loading: true, pedestal});

        const response = await axios.post(url, body, {headers});

        this.setState({loading: false});

        const data = response.data;

        const success = data.success;

        this.getPedestalAmount();

        if (success) {
            const pedestalAmount = data.revertedAmount;
            const miraAmount = data.miraAmount || 0;
            progress.amount = pedestalAmount;
            progress.action = "Revert"
            pedestal.progress = progress;

            const {mira} = this.state;
            const miraProgress = mira.progress;
            miraProgress.amount = miraAmount;

            this.setState({pedestal, mira});
            PopupMessage.success("Revert Pedestal Success");
        } else {
            PopupMessage.error("Revert Pedestal Failed");
        }
    }

    //#region RENDER
    renderContent() {
        const {pedestal} = this.state;
        const styles = {
            h5: {display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px'},
            h6: {display: "flex", alignItems: "center", marginBottom: '10px'},
        }

        return <Grid container sm={12} spacing={2}>
            <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                <Grid sm={8}>
                    <Typography variant="h5">Get Data</Typography>
                </Grid>
                <Grid container style={styles.h6}>
                    <Grid item sm={2}>
                        <Typography variant="h6">Offset:</Typography>
                    </Grid>
                    <Grid item sm={6}>
                        <TextField
                            inputProps={{type: "number"}}
                            value={pedestal.offset}
                            onChange={(e) => this.onChangePedestalData(e, "offset")}
                        />
                    </Grid>
                </Grid>

                <Grid container style={styles.h6}>
                    <Grid item sm={2}>
                        <Typography variant="h6">Amount:</Typography>
                    </Grid>
                    <Grid item sm={6}>
                        <TextField
                            inputProps={{type: "number"}}
                            value={pedestal.amount}
                            onChange={(e) => this.onChangePedestalData(e, "amount")}
                        />
                    </Grid>
                </Grid>

                <Grid container style={styles.h6}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        onClick={this.getListUser}
                    >
                        Copy to clipboard
                    </Button>
                </Grid>
            </Grid>

            <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                <Grid item sm={12}>
                    <Typography variant="h5">Fix User Data</Typography>
                </Grid>

                <Grid item sm={12}>
                    <TextField
                        placeholder="Enter user ids separated by comma, ex: 1,2,3"
                        value={pedestal.userPedestal}
                        onChange={(e) => this.onChangePedestalData(e, "userPedestal")}
                        multiline
                        rows={5}
                        fullWidth
                    />
                </Grid>

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={3}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="warning"
                            onClick={this.onRevertFixPedestal}
                        >
                            <HistoryIcon />
                            Revert Fixing
                        </Button>
                    </Grid>
                    <Grid item sm={3}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            onClick={this.onFixPedestal}
                        >
                            <BuildIcon />
                            Fix Pedestal
                        </Button>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>
    }

    renderProgress = () => {
        const {pedestal} = this.state;
        const {progress} = pedestal;

        // If progress is empty, return empty string
        if (Object.keys(progress).length === 0) {
            return "";
        }

        const str = `
            Total: ${progress.totalUser},
            ${progress.action}: ${progress.amount}
        `;

        return <Typography variant="h6">
            {str}
        </Typography>;
    }

    renderRefundMira = () => {
        const {mira} = this.state;
        const {progress} = mira;
        const styles = {
            h5: {display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px'},
            h6: {display: "flex", alignItems: "center", marginBottom: '10px'},
        }

        const str = `
            Total: ${progress.totalUser},
            ${progress.action}: ${progress.amount},
            Refund Money: ${Helpers.formatNumber(progress.refundAmount)}
        `;

        return <Paper className='root' elevation={0}>
            <Typography variant="h4" style={{marginBottom: '50px'}}>
                Number of Player possible to refund Mira: {Helpers.formatNumber(this.state.mira.total)}
            </Typography>

            <Grid container sm={12} spacing={2}>
                <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                    <Grid sm={8}>
                        <Typography variant="h5">Get Data</Typography>
                    </Grid>
                    <Grid container style={styles.h6}>
                        <Grid item sm={2}>
                            <Typography variant="h6">Offset:</Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                inputProps={{type: "number"}}
                                value={mira.offset}
                                onChange={(e) => this.onChangeMiraData(e, "offset")}
                            />
                        </Grid>
                    </Grid>

                    <Grid container style={styles.h6}>
                        <Grid item sm={2}>
                            <Typography variant="h6">Amount:</Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                inputProps={{type: "number"}}
                                value={mira.amount}
                                onChange={(e) => this.onChangeMiraData(e, "amount")}
                            />
                        </Grid>
                    </Grid>

                    <Grid container style={styles.h6}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            onClick={this.getListRefundMira}
                        >
                            Copy to clipboard
                        </Button>
                    </Grid>
                </Grid>

                <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                    <Grid item sm={12}>
                        <Typography variant="h5">Refund</Typography>
                    </Grid>

                    <Grid item sm={12}>
                        <TextField
                            placeholder="Enter user ids separated by comma, ex: 1,2,3"
                            value={mira.userPedestal}
                            onChange={(e) => this.onChangeMiraData(e, "userPedestal")}
                            multiline
                            rows={5}
                            fullWidth
                        />
                    </Grid>

                    <Grid item container sm={12} justifyContent={"flex-end"}>
                        {/* <Grid item sm={3}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="warning"
                                onClick={this.onRevertFixPedestal}
                            >
                                <HistoryIcon />
                                Revert Fixing
                            </Button>
                        </Grid> */}
                        <Grid item sm={3}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onRefundMira}
                            >
                                <BuildIcon />
                                Refund!!!
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            <Typography variant="h6">
                {str}
            </Typography>

            {this.state.loading && <LoadingIndicator classes="" loadingTextPlaceholder="Requesting!!!!!" loadingText={true} />}
        </Paper>
    }

    renderFixBuilding = () => {
        const {building} = this.state;
        const {progress} = building;
        const styles = {
            h5: {display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px'},
            h6: {display: "flex", alignItems: "center", marginBottom: '10px'},
        }

        const str = `
            Total: ${progress.totalUser},
            ${progress.action}: ${progress.amount}
        `;

        return <Paper className='root' elevation={0}>
            <Typography variant="h4" style={{marginBottom: '50px'}}>
                Number of Player Need to fix: {Helpers.formatNumber(this.state.building.total)}
            </Typography>

            <Grid container sm={12} spacing={2}>
                <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                    <Grid sm={8}>
                        <Typography variant="h5">Get Data</Typography>
                    </Grid>
                    <Grid container style={styles.h6}>
                        <Grid item sm={2}>
                            <Typography variant="h6">Offset:</Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                inputProps={{type: "number"}}
                                value={building.offset}
                                onChange={(e) => this.onChangeBuildingData(e, "offset")}
                            />
                        </Grid>
                    </Grid>

                    <Grid container style={styles.h6}>
                        <Grid item sm={2}>
                            <Typography variant="h6">Amount:</Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                inputProps={{type: "number"}}
                                value={building.amount}
                                onChange={(e) => this.onChangeBuildingData(e, "amount")}
                            />
                        </Grid>
                    </Grid>

                    <Grid container style={styles.h6}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            onClick={this.getListBuilding}
                        >
                            Copy to clipboard
                        </Button>
                    </Grid>
                </Grid>

                <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                    <Grid item sm={12}>
                        <Typography variant="h5">Refund</Typography>
                    </Grid>

                    <Grid item sm={12}>
                        <TextField
                            placeholder="Enter user ids separated by comma, ex: 1,2,3"
                            value={building.userPedestal}
                            onChange={(e) => this.onChangeBuildingData(e, "userPedestal")}
                            multiline
                            rows={5}
                            fullWidth
                        />
                    </Grid>

                    <Grid item container sm={12} justifyContent={"flex-end"}>
                        {/* <Grid item sm={3}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="warning"
                                onClick={this.onRevertFixPedestal}
                            >
                                <HistoryIcon />
                                Revert Fixing
                            </Button>
                        </Grid> */}
                        <Grid item sm={3}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onFixBuilding}
                            >
                                <BuildIcon />
                                Fix Building!!!
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            <Typography variant="h6">
                {str}
            </Typography>

            {this.state.loading && <LoadingIndicator classes="" loadingTextPlaceholder="Requesting!!!!!" loadingText={true} />}
        </Paper>
    }

    render() {
        const {pedestal} = this.state;
        const {mira} = this.state;
        return <div className="contentPadding" style={{width: "100%"}}>
            <Paper className="root" elevation={0}>
                <Typography variant="h4" style={{marginBottom: '50px'}}>
                    Number of Player still use old Pedestal: {pedestal.total}
                </Typography>

                {this.renderContent()}
                {this.renderProgress()}
                {this.state.loading && <LoadingIndicator classes="" loadingTextPlaceholder="Requesting!!!!!" loadingText={true} />}

            </Paper>
            {this.renderRefundMira()}
            {this.renderFixBuilding()}

            {/* <Paper className="root" elevation={0}>
                <Typography variant="h4" style={{marginBottom: '50px'}}>
                    Number of Player has Pedestal but don't have Mira: {mira.total}
                </Typography>
            </Paper> */}
        </div>
    }
}